import React, { Component } from 'react';
import {View,Text,ListView,ScrollView,TouchableHighlight,Animated, FlatList,Dimensions, Image,Linking,Alert,Platform,ActivityIndicator, PanResponder} from 'react-native';
import {StyleContext, styleInfo} from '../styleC';

import firebase from './firebase';
import strings from '../strings';
import info from '../info';
const timer = require('react-native-timer');
import MavMiniButton from './mavMiniButton';
import MavAlert from './mavAlert';
import SncfInfo from './sncfInfo';
import FlightInfo from './flightInfo';

import Modal from './modal';
export default class App extends Component {
  constructor(props) {
    super(props);
    
    
    
    var testAdr=this.props.data.description.split(this.props.data.userDescription+", ").join("");
    testAdr=testAdr.split(", France").join("");
    testAdr=testAdr.split(", Suisse").join("");
    testAdr=testAdr.split(", Belgique").join("");
    var adress=testAdr.split(", ").join("\n");

    console.log("adress ="+adress)
    
    this.state={
        adress:adress,
        
    } 

  }

  

 

     

 

  componentDidMount(){
   console.log("POIMapDetail mount")
   
console.log(this.props.data)
    

  }

 

  itineraryChoice(){
        this.alert.onAlert({title:strings.whatDoing,buttons:[
              {text: strings.startFromHere,onPress: () => {this.props.close("from")}},  
              {text: strings.goToHere,onPress: () => {this.props.close("to")}},
              {text: strings.cancel, style:"cancel",onPress: () => {}}
              ] })

  }


  render() {

    return (
      <StyleContext.Consumer>{style => 

       


       <Modal animationType="slide" transparent={true} visible={true} >

        <View style={{alignItems:"center",justifyContent:"center",height:Dimensions.get('window').height,width:Dimensions.get('window').width,}}>

              <TouchableHighlight underlayColor={"rgba(0,0,0,0.5)"} style={{height:Dimensions.get('window').height,width:Dimensions.get('window').width,backgroundColor:"rgba(0,0,0,0.5)",position:"absolute",top:0, left:0}} onPress={() => { this.props.close()}}>
                  <View/>
              </TouchableHighlight>



       <ScrollView style={{ backgroundColor:style.backgroundColor, width:'95%', maxHeight:Dimensions.get('window').height*0.75,bottom:(this.props.center==true)?undefined:20, position:"absolute"}}>


        <View style={{justifyContent:"space-between",marginTop:10,   flexDirection:"row",marginLeft:"5%", marginRight:"5%"}}>
            <View>
                <Text numberOfLines={1} style={{color: style.textInputColor,fontSize: style.textInputFontSize*1.4*((this.props.maxiMode==true)?2:1),fontWeight: 'bold',maxWidth:((Dimensions.get('window').width<style.mobileSizeMax)?Dimensions.get('window').width:style.minimizeWidth)*0.8}}>{this.props.data.userDescription}</Text>
                <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.8*((this.props.maxiMode==true)?2:1)}}>{this.state.adress}</Text>
            </View>

          
                    
        {this.props.disableFromTo!=true && <MavMiniButton  icon={(style.mode=="dark")?require('../assets/futureRace_black.png'):require('../assets/futureRace_white.png')} text={strings.itinerary} onlyButton={true}  onPress={()=>{  this.itineraryChoice()  }} />}



        </View>

       {this.props.data.picture!=undefined && <Image source={this.props.data.picture} style={{resizeMode:"contain",height:250,width:"90%", marginLeft:"5%"}}/>}



        {((this.props.data.descriptionName!=undefined && this.props.data.descriptionName!="") || (this.props.data.descriptionLongName!=undefined && this.props.data.descriptionLongName!="") ) && <View style={{ marginLeft:"5%", marginRight:"5%"}}>
          <Text style={{marginTop:10,color: style.textInputColor,fontSize: style.textInputFontSize*0.8*((this.props.maxiMode==true)?2:1),fontWeight: 'bold'}}>{strings.description}</Text>
            {(this.props.data.descriptionName!=undefined && this.props.data.descriptionName!="") && <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.8*((this.props.maxiMode==true)?2:1)}}>{this.props.data.descriptionName}</Text>}
            {(this.props.data.descriptionLongName!=undefined && this.props.data.descriptionLongName!="") && <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.8*((this.props.maxiMode==true)?2:1)}}>{this.props.data.descriptionLongName}</Text>}

        </View>}

     

       {(this.props.data.descriptionPlace!=undefined && this.props.data.descriptionPlace!="") && <View style={{ marginLeft:"5%", marginRight:"5%"}}>
          <Text style={{marginTop:10,color: style.textInputColor,fontSize: style.textInputFontSize*0.8*((this.props.maxiMode==true)?2:1),fontWeight: 'bold'}}>{strings.description}</Text>
          <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.8*((this.props.maxiMode==true)?2:1)}}>{this.props.data.descriptionPlace}</Text>

        </View>}

      {(this.props.data.pickUpLocationDescription!=undefined && this.props.data.pickUpLocationDescription!="") && <View style={{ marginLeft:"5%", marginRight:"5%"}}>
          <Text style={{marginTop:10,color: style.textInputColor,fontSize: style.textInputFontSize*0.8*((this.props.maxiMode==true)?2:1),fontWeight: 'bold'}}>{strings.pickUpLocation}</Text>
          <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.8*((this.props.maxiMode==true)?2:1)}}>{this.props.data.pickUpLocationDescription}</Text>

          </View>}
        
            {this.props.data.icon=="train" && <SncfInfo style={{marginTop:10}} stationPosition={this.props.data.coordinates} getStationInfo={true} />}
            {(this.props.data.icon=="flight" && this.props.data.iata!=undefined) && <FlightInfo style={{marginTop:10}} iata={this.props.data.iata} getAirportInfo={true} />}


          <View style={{width:50, height:50}} />


         </ScrollView>



    </View>
   
    <MavAlert ref={alert => {this.alert = alert;}}/>
    </Modal>

     


    }</StyleContext.Consumer>  
    );
  }
} 

